import { PdfTemplate, TableSorting } from "components";
import moment from "moment";
import { cellValuePdf, RowExportTypePdf } from "types";
import { APPROVAL, convertNumber } from "utils";
import { TransferType } from "../types";

export function ExportPdf(props: {
    data: TransferType[],
    filter: {
        dateFrom?: string | undefined,
        dateTo?: string | undefined
    },
    tableActive: TableSorting[]
}) {

    const activeCols = props.tableActive.filter(col => col.isActive !== false)

    const columns = [
        { header: "NO", key: "no", width: 5 },
        ...activeCols
            .map(col => renderColumn(col.value as string))
            .filter((col): col is NonNullable<typeof col> => col !== undefined),
    ]

    const dataMap = props.data.map((item, index) => {
        const row: Record<string, any> = { no: index + 1 }

        activeCols.forEach(col => {
            const colMeta = renderColumn(col.value as string)
            if (colMeta) {
                row[colMeta.key] = renderCellValue(col.value as string, item)
            }
        })

        return row
    })

    return (
        <PdfTemplate
            data={dataMap}
            module="INVENTORY"
            title="ITEM TRANSFER"
            column={columns}
            date={`${moment(props.filter.dateFrom).format("DD/MM/YYYY")} - ${moment(props.filter.dateTo).format("DD/MM/YYYY")}`}
        />
    )
}

function numberFormat(value: number): cellValuePdf {
    return {
        text: convertNumber(value).intoCurrency,
        style: {
            textAlign: "right",
            fontWeight: "bold"
        }
    }
}

function renderColumn(title: string): { header: string; key: string | number; width: number } | undefined {
  const map: Record<string, { header: string; key: keyof RowExportTypePdf; width: number }> = {
    "trx_code": { header: "TRANSFER ID#", key: "trx_code", width: 20 },
    "transaction_date": { header: "DATE", key: "transaction_date", width: 15 },
    "location_from": { header: "FROM LOCATION", key: "location_from", width: 30 },
    "location_to": { header: "TO LOCATION", key: "location_to", width: 30 },
    "employee_name": { header: "TRADER", key: "employee_name", width: 20 },
    "transfer_status": { header: "TRANSFER", key: "transfer_status", width: 15 },
    "approval_status": { header: "APPROVED", key: "approval_status", width: 15 },
    "MEMO": { header: "MEMO", key: "memo", width: 30 },
    "qty_transfer": { header: "QTY TRANSFERED", key: "qty_transfer", width: 20 },
    "qty_rejected": { header: "REJECTED", key: "qty_rejected", width: 20 },
    "qty_received": { header: "RECEIVED", key: "qty_received", width: 20 },
  }
  return map[title]
}

function renderCellValue(title: string, item: any): any {
  switch (title) {
    case "trx_code":
      return item.trx_code
    case "transaction_date":
      return moment(item.transaction_date).format("DD/MM/YYYY")
    case "location_from":
      return item.location_from?.location_name
    case "location_to":
      return item.location_to?.location_name
    case "employee_name":
      return item.employee.employee_name
    case "transfer_status": {
      const ts = Number(item.transfer_status)
      return ts === 1 ? "Open" : ts === 2 ? "Closed" : ts === 3 ? "Completed" : "-"
    }
    case "approval_status":
      return APPROVAL[item.approval_status]
    case "memo":
      return item.memo
    case "qty_transfer":
      return numberFormat(item.qty_transfer)
    case "qty_rejected":
      return numberFormat(item.qty_rejected)
    case "qty_received":
      return numberFormat(item.qty_received)
    default:
      return undefined
  }

}
